import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Check, Plus, PackageCheck } from "lucide-react";
import { AddOnDef } from "./plans-data";

interface Props {
  addOns: AddOnDef[];
  selectedAddOns: string[];
  toggleAddOn: (id: string) => void;
  currentPlan?: string;
  billingCycle: "monthly" | "yearly";
  getPrice: (monthly: number) => number;
}

const AddOnSection = ({ addOns, selectedAddOns, toggleAddOn, currentPlan, billingCycle, getPrice }: Props) => (
  <div className="space-y-4">
    <div className="text-center">
      <h2 className="text-xl font-bold">إضافات مرنة (Add-ons)</h2>
      <p className="text-sm text-muted-foreground">خصّص نظامك — أضف ما تحتاجه فقط</p>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {addOns.map((addon) => {
        const isIncluded = currentPlan ? addon.includedIn.includes(currentPlan) : false;
        const isSelected = selectedAddOns.includes(addon.id);
        const Icon = addon.icon;
        const price = getPrice(addon.monthlyPrice);

        return (
          <Card
            key={addon.id}
            className={`transition-all ${isSelected ? "ring-2 ring-primary" : ""} ${isIncluded ? "opacity-60" : ""}`}
          >
            <CardContent className="p-5 space-y-3">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded-xl bg-accent flex items-center justify-center">
                    <Icon className="w-5 h-5 text-primary" />
                  </div>
                  <div>
                    <p className="font-semibold text-sm">{addon.name}</p>
                    <p className="text-xs text-muted-foreground">{addon.description}</p>
                  </div>
                </div>
              </div>

              <ul className="space-y-1.5">
                {addon.features.map((f, i) => (
                  <li key={i} className="flex items-center gap-1.5 text-xs text-muted-foreground">
                    <Check className="w-3 h-3 text-green-600 shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>

              <div className="flex items-center justify-between pt-2 border-t">
                <span className="font-bold text-sm">
                  +{price.toLocaleString()} ج.م/{billingCycle === "yearly" ? "سنة" : "شهر"}
                </span>
                {isIncluded ? (
                  <Badge variant="secondary" className="flex items-center gap-1 text-xs">
                    <PackageCheck className="w-3 h-3" />
                    مشمولة في خطتك
                  </Badge>
                ) : (
                  <Button
                    size="sm"
                    variant={isSelected ? "default" : "outline"}
                    onClick={() => toggleAddOn(addon.id)}
                    className="text-xs"
                  >
                    {isSelected ? (
                      <span className="flex items-center gap-1"><Check className="w-3 h-3" /> مُضافة</span>
                    ) : (
                      <span className="flex items-center gap-1"><Plus className="w-3 h-3" /> إضافة</span>
                    )}
                  </Button>
                )}
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  </div>
);

export default AddOnSection;
